export const STORAGE_KEYS = {
  AUTH_STATE: 'hs-auth-state',
  SSO_STATE: 'hs-sso-state',
  CLIENT_CONFIG: 'hs-client-config-state',
  TM_INITIALS: 'hs-tm-initials-state',
  POA_FLOW: 'hs-poa-flow-state',
} as const

export type Key = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS]
